import { Component, effect, inject } from '@angular/core';
import {
	VehicleActionEnum,
	VehicleRecordDto,
	VehicleStatusEnum,
	vehicleStatusToColor,
	vehicleValidators,
} from '@splitsecondconnect/ultramarine-shared';
import { take } from 'rxjs';

import { BaseMenuPortalButtonComponent } from '../../../../../shared/base-classes/base-menu-portal-button.component';
import { ListItemMenuContainerComponent } from '../../../../../shared/components/containers/list-item-menu-container/list-item-menu-container.component';
import { UltraActionsNavigationComponent } from '../../../../../shared/components/ultramarine-ui/ultra-actions-navigation/ultra-actions-navigation.component';
import { UltraMenuItemComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item/ultra-menu-item.component';
import { UltraMenuItemWrapperComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item-wrapper/ultra-menu-item-wrapper.component';
import { UltraNavigationItem } from '../../../../../shared/models/ultra-navigation-item.model';
import { RecordEventsService } from '../../../../../shared/services/record-events.service';
import { VehiclesService } from '../../vehicles.service';

@Component({
	selector: 'app-vehicle-status-button',
	templateUrl: 'vehicle-status-button.component.html',
	imports: [
		UltraMenuItemWrapperComponent,
		UltraMenuItemComponent,
		ListItemMenuContainerComponent,
		UltraActionsNavigationComponent,
	],
})
export class VehicleStatusButtonComponent extends BaseMenuPortalButtonComponent<VehicleRecordDto> {
	private _vehiclesService = inject(VehiclesService);
	private _recordEventsService = inject(RecordEventsService);

	public menuData: UltraNavigationItem[] = [];
	constructor() {
		super();
		effect(() => {
			if (this.isEditMode()) {
				return;
			}
			this._vehiclesService.getRecord(this.id()).subscribe();
		});
		this._vehiclesService.record$.subscribe((res) => {
			this.recordDataDtoSignal.set(res?.data);
		});
		effect(() => {
			if (!this.recordDataDtoSignal()) {
				return;
			}
			this.menuData = [
				{
					title: 'vehicles|status|in-park',
					color: vehicleStatusToColor(VehicleStatusEnum.IN_PARK),
					type: 'basic',
					icon: 'local_parking',
					disabled: !this._canPerformAction(VehicleActionEnum.PARK),
					function: () => {
						this._executeStatusAction(VehicleStatusEnum.IN_PARK);
					},
				},
				{
					title: 'vehicles|status|hard-hold',
					color: vehicleStatusToColor(VehicleStatusEnum.HARD_HOLD),

					type: 'basic',
					icon: 'pause_circle',

					disabled: !this._canPerformAction(VehicleActionEnum.HARD_HOLD),
					function: () => {
						this._executeStatusAction(VehicleStatusEnum.HARD_HOLD);
					},
				},
				{
					title: 'vehicles|status|out-of-service',
					color: vehicleStatusToColor(VehicleStatusEnum.OUT_OF_SERVICE),

					type: 'basic',
					icon: 'broken_image',
					disabled: !this._canPerformAction(VehicleActionEnum.OUT_OF_SERVICE),
					function: () => {
						this._executeStatusAction(VehicleStatusEnum.OUT_OF_SERVICE);
					},
				},
			];
		});
	}

	protected _canPerformAction(action: VehicleActionEnum): boolean {
		const validationResult = vehicleValidators.canPerformAction(
			this.recordDataDtoSignal(),
			action,
		);

		return validationResult.isValid;
	}

	private _executeStatusAction(status: VehicleStatusEnum) {
		this.modalsService.dismissTopModal();
		const recordDto = this.recordDataDtoSignal();
		recordDto.status = status;
		this._vehiclesService
			.updateRecordStatus(recordDto.id, recordDto.status)
			.pipe(take(1))
			.subscribe(() => {
				this._recordEventsService.onTaskUpdateSubmitted.next(null);
			});
	}
}
